import { useTranslation } from 'react-i18next';
import { StoryAccess } from '../../../../../services';

export const useCreateStoryAccessFilter = () => {
  const { t: ctxT } = useTranslation('', { keyPrefix: 'createStorySettings' });

  return {
    groups: [
      {
        id: 'access',
        multiCheck: true,
        items: [
          {
            id: StoryAccess.EDITOR_LIMITED,
            label: ctxT('access-editor-limited'),
            value: StoryAccess.EDITOR_LIMITED,
          },
          {
            id: StoryAccess.READER,
            label: ctxT('access-reader'),
            value: StoryAccess.READER,
          },
        ],
      },
    ],
  };
};
